"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _expressionAtlasNumberFormat = _interopRequireDefault(require("@ebi-gene-expression-group/expression-atlas-number-format"));

var _trimEllipsify = _interopRequireDefault(require("./trimEllipsify"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var scientificNotation = function scientificNotation(value) {
  return /*#__PURE__*/_react["default"].createElement(_expressionAtlasNumberFormat["default"], {
    value: value,
    style: {
      fontWeight: "bold"
    }
  });
};

var roundTStat = function roundTStat(n) {
  return n ? +n.toFixed(4) : "";
};

var _tinySquare = function _tinySquare(colour) {
  return /*#__PURE__*/_react["default"].createElement("span", {
    key: "Tiny ".concat(colour, " square"),
    style: {
      border: "1px rgb(192, 192, 192) solid",
      marginRight: "0.25rem",
      width: "0.6rem",
      height: "0.6rem",
      display: "inline-block",
      backgroundColor: colour
    }
  });
};

var _bold = function _bold(value) {
  return /*#__PURE__*/_react["default"].createElement("b", null, value);
};

var _elt = function _elt(E, name, value, format) {
  return Boolean(name && value) && /*#__PURE__*/_react["default"].createElement(E, {
    key: "".concat(name, " ").concat(value)
  }, typeof name === "string" ? "".concat(name, ": ") : name, value.length > 50 && /*#__PURE__*/_react["default"].createElement("br", null), (format || _bold)(value));
};

var _div = _elt.bind(void 0, "div");

var _span = _elt.bind(void 0, "span");

var yInfo = function yInfo(_ref) {
  var config = _ref.config,
      yLabel = _ref.yLabel;
  return _div(config.yAxisLegendName, yLabel);
};

var xInfo = function xInfo(_ref2) {
  var xAxisLegendName = _ref2.xAxisLegendName,
      config = _ref2.config,
      xLabel = _ref2.xLabel;
  return _div(xAxisLegendName || config.xAxisLegendName, xLabel);
};

var tooltipValueMaxLength = 30;

var _comparisonDiv = function _comparisonDiv(name, v1, v2, format) {
  return name && v1 && v2 ? /*#__PURE__*/_react["default"].createElement("div", {
    key: "".concat(name, " ").concat(v1, " ").concat(v2)
  }, "".concat(name, ": "), v1.length + v2.length > tooltipValueMaxLength * 2 ? /*#__PURE__*/_react["default"].createElement("br", null) : null, (format || _bold)((0, _trimEllipsify["default"])(v1, tooltipValueMaxLength)), /*#__PURE__*/_react["default"].createElement("i", {
    style: {
      margin: "0.25rem"
    }
  }, "vs"), (format || _bold)((0, _trimEllipsify["default"])(v2, tooltipValueMaxLength))) : null;
};

var prettyName = function prettyName(name) {
  return name.toLowerCase().replace(/\w\S*/, function (txt) {
    return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();
  });
};

var xPropertiesBaselineList = function xPropertiesBaselineList(_ref3) {
  var xProperties = _ref3.xProperties;
  return xProperties.filter(function (property) {
    return property.contrastPropertyType !== "SAMPLE" // would fail with showing too much stuff which isn't catastrophic
    ;
  }).map(function (property) {
    return _div(prettyName(property.propertyName), property.testValue);
  });
};

var xPropertiesDifferentialList = function xPropertiesDifferentialList(_ref4) {
  var xProperties = _ref4.xProperties;
  return xProperties.filter(function (property) {
    return property.testValue !== property.referenceValue;
  }).map(function (property) {
    return _comparisonDiv(prettyName(property.propertyName), property.testValue, property.referenceValue);
  });
};

var differentialNumbers = function differentialNumbers(_ref5) {
  var colour = _ref5.colour,
      foldChange = _ref5.foldChange,
      pValue = _ref5.pValue,
      tStat = _ref5.tStat;
  return [/*#__PURE__*/_react["default"].createElement("div", {
    key: ""
  }, _tinySquare(colour), _span( /*#__PURE__*/_react["default"].createElement("span", null, "Log", /*#__PURE__*/_react["default"].createElement("sub", null, "2"), "-fold change: "), foldChange)), _div("Adjusted p-value", pValue, scientificNotation), _div("T-statistic", roundTStat(tStat))];
};

var baselineNumbers = function baselineNumbers(_ref6) {
  var colour = _ref6.colour,
      value = _ref6.value,
      unit = _ref6.unit,
      replicates = _ref6.replicates;
  return [_tinySquare(colour), _span("Expression level", value ? "".concat(value, " ").concat(unit) : "Below cutoff")].concat(replicates ? _div("Number of biological replicates", replicates) : []);
};

var HeatmapCellTooltip = function HeatmapCellTooltip(props) {
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      whiteSpace: "pre",
      background: "rgba(255, 255, 255, .85)",
      padding: "5px",
      border: "1px solid darkgray",
      borderRadius: "3px",
      boxShadow: "2px 2px 2px darkslategray"
    }
  }, yInfo(props), props.config.isMultiExperiment ? xInfo(props) : props.config.isDifferential ? xPropertiesDifferentialList(props) : xPropertiesBaselineList(props), props.config.isDifferential ? differentialNumbers(props) : baselineNumbers(props));
};

HeatmapCellTooltip.propTypes = {
  config: _propTypes["default"].shape({
    isDifferential: _propTypes["default"].bool.isRequired,
    isMultiExperiment: _propTypes["default"].bool.isRequired,
    xAxisLegendName: _propTypes["default"].string.isRequired,
    yAxisLegendName: _propTypes["default"].string.isRequired
  }).isRequired,
  colour: _propTypes["default"].string.isRequired,
  xLabel: _propTypes["default"].string.isRequired,
  xProperties: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    propertyName: _propTypes["default"].string.isRequired,
    referenceValue: _propTypes["default"].string,
    // present iff differential
    testValue: _propTypes["default"].string.isRequired
  })),
  yLabel: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].number.isRequired,
  unit: _propTypes["default"].string.isRequired,
  replicates: _propTypes["default"].number,
  foldChange: _propTypes["default"].number,
  pValue: _propTypes["default"].number,
  tStat: _propTypes["default"].number,
  xAxisLegendName: _propTypes["default"].string
};
var _default = HeatmapCellTooltip;
exports["default"] = _default;